import React from 'react';

type SectionTitleProps = {
  title: React.ReactNode;
  borderColor?: string;
  className?: string;
  ico?: React.ReactNode;
};

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  borderColor = 'secondary',
  className = '',
  ico = null,
}) => {
  return (
    <div
      className={`section-title-container mb-3 ${
        borderColor === 'secondary' ? 'secondary' : 'primary'
      } ${className || ''}`}
    >
      <h3>{title}</h3>
      {ico}
    </div>
  );
};

export default SectionTitle;
